<template>
    <div id="show-carnet">
          <div id="mostra-carnet">
              <div id="fons-carnet" class="u-shadow-v2">
                  <img src="/images/plantilla_alumnes_front.jpg"/>
              </div>
              <div id="thumb-carnet" class="object-fit_fill ">
                  <img :src="fonsUrl()" />
              </div>
              <div id="nom-usuari">
                <span>{{ this.nom }}</span>
              </div>
            <div id="description">
              <span>{{ this.estudi }}</span>
            </div>
          </div>
    </div>
</template>

<script>
    export default {
        name: "show-carnet",
        props:{
          nom: { Required: false },
          estudi: { Required: false },
          url: { Required: false },
        },
      data() {
          return {
            defaultFons: '/images/plantilla_alumnes_front.jpg',
          }
        },
        methods:{
          fonsUrl() {
            return this.url !== '' ? this.url : this.defaultFons;
          }
        }
    }
</script>

<style scoped>
    .object-fit_fill { object-fit: fill }

    #show-carnet{
        max-width: 600px;
    }

    #mostra-carnet{
        position: relative;
        max-width: 600px;
        width: 600px;
        height: 375px;
    }

    #fons-carnet{
        z-index: 1;
        border: 1px #ccc solid;
        border-radius: 5px;
    }

    #fons-carnet img{
        width: 100%;
        height: auto;
    }

    #nom-usuari {
        position: relative;
        top: -25%;
        z-index: 2;
        padding-left: 5%;
    }

    #nom-usuari span{
        font-weight: bold;
        font-size: 16px
    }

    #description {
        position: relative;
        top: -28%;
        z-index: 2;
        padding-left: 5%;
    }

    #description span{
        font-weight: bold;
        font-size: 12px;
    }

    #thumb-carnet{
      position: absolute;
      top: 30px;
      right: 35px;
      z-index: 2;
      width: 100%;
      height: 200px;
      min-height: 150px;
      max-width: 160px;
      max-height: 180px;
    }

    #thumb-carnet img{
        width: 100%;
        height: auto;
        float: right;
        border-radius: 2% !important;
    }

    .u-shadow-v2 {
      box-shadow: 0 10px 6px -6px rgba(0, 0, 0, 0.2);
    }

    #nom-usuari {
      position: relative;
      top: -23%;
      z-index: 2;
      padding-left: 6%;
    }

    #nom-usuari span{
      font-weight: bold;
      font-size: 18px
    }

    #description {
      position: relative;
      top: -23%;
      z-index: 2;
      padding-left: 6%;
    }

    #description span{
      font-weight: bold;
      font-size: 14px;
    }

    @media only screen and (max-width: 600px) {
      #show-carnet{
        max-width: 400px;
      }

      #mostra-carnet{
        position: relative;
        max-width: 400px;
        width: 400px;
        height: 250px;
      }

      #thumb-carnet{
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 2;
        width: 100%;
        min-height: 150px;
        max-width: 110px;
        max-height: 180px;
      }

      #nom-usuari {
        position: relative;
        top: -25%;
        z-index: 2;
        padding-left: 5.5%;
      }

      #nom-usuari span{
        font-weight: bold;
        font-size: 16px
      }

      #description {
        position: relative;
        top: -28%;
        z-index: 2;
        padding-left: 5.5%;
      }

      #description span{
        font-weight: bold;
        font-size: 12px;
      }
    }

</style>
